import { cloneElement, ReactElement, ReactNode } from 'react';
import './ErrorField.css';
import { FieldError } from '@anticatrade/shared';
import SlIcon from '@shoelace-style/shoelace/dist/react/icon/index.js';

interface ErrorFieldProps {
	name: string;
	error: FieldError | undefined;
	className?: string;
	children: ReactElement;
	footer?: ReactNode;
}

const ErrorField = ({ name, error, className, children, footer }: ErrorFieldProps) => {
	const field = cloneElement(children as any, { name: name });

	const errorMessage = error?.field === name && (
		<div className='error__field-error'>
			<SlIcon className='error__field-error-icon' name='exclamation-circle' />
			<span dangerouslySetInnerHTML={{ __html: error.message }} />
		</div>
	);

	return (
		<div
			className={`error__field${className != null ? ' ' + className : ''}`}
			id={`error__field-${name}`}
		>
			{field}
			{footer != null ? (
				<div className='error__field-footer'>
					{errorMessage}
					{footer}
				</div>
			) : (
				errorMessage
			)}
		</div>
	);
};

export { ErrorField };
